module.exports = __webpack_public_path__ + "static/media/REXR_Stripe_rgb.63121684.png";